/* @flow */
import ConnectedBankAccount from 'entities/ConnectedBankAccount';
import type { Action } from 'action';
import { Map } from 'immutable';

export type ConnectedBankAccountRequest = {
  connectedBankAccount?: ConnectedBankAccount,
  isLoading?: true,
  error?: string,
};

export type State = Map<string, ConnectedBankAccountRequest>
export const initialState: State = new Map();

// typecheck: ignore statement
export default function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case 'connectedBankAccountRequest/LOAD_REQUEST':
      return state.set(action.token, { isLoading: true });
    case 'connectedBankAccountRequest/LOAD_SUCCESS':
      return state.set(action.token, { connectedBankAccount: action.connectedBankAccount });
    case 'connectedBankAccountRequest/LOAD_ERROR':
      return state.set(action.token, { error: action.error });
    default:
      return state;
  }
}

export type loadAction = {
  type: 'connectedBankAccountRequest/LOAD_REQUEST',
  token: string,
};

export function load(token: string): loadAction {
  return {
    type: 'connectedBankAccountRequest/LOAD_REQUEST',
    token,
  };
}

export type loadSuccessAction = {
  type: 'connectedBankAccountRequest/LOAD_SUCCESS',
  connectedBankAccount: ConnectedBankAccount,
  token: string,
};

export function loadSuccess(token: string, connectedBankAccount: ConnectedBankAccount): loadSuccessAction {
  return {
    type: 'connectedBankAccountRequest/LOAD_SUCCESS',
    connectedBankAccount,
    token,
  };
}

export type loadErrorAction = {
  type: 'connectedBankAccountRequest/LOAD_ERROR',
  error: string,
  token: string,
};

export function loadError(token: string, error: string): loadErrorAction {
  return {
    type: 'connectedBankAccountRequest/LOAD_ERROR',
    error,
    token,
  };
}

export type ConnectedBankAccountRequestAction = loadAction | loadSuccessAction | loadErrorAction;



// WEBPACK FOOTER //
// ./src/reducers/connectedBankAccountRequest.js